/**
 * Stable CSS class names for E2E — LCW cargo fee management.
 */
export const LCWFEE = {
    page: 'lcw-cargo-fee-management-page',
    shellPaper: 'lcw-cargo-fee-management-page__shell',
    breadcrumbSection: 'lcw-cargo-fee-management-page__breadcrumb-section',
    loadingSection: 'lcw-cargo-fee-management-page__loading-section',
    tabsWrap: 'lcw-cargo-fee-management-page__tabs-wrap',
    tabsRoot: 'lcw-cargo-fee-management-page__tabs',
    tabFeeList: 'lcw-cargo-fee-management-page-input--tab-fee-list',
    tabBulkUpload: 'lcw-cargo-fee-management-page-input--tab-bulk-upload',
    tabPanelFeeList: 'lcw-cargo-fee-management-page__tab-panel-fee-list',
    tabPanelBulkUpload: 'lcw-cargo-fee-management-page__tab-panel-bulk-upload',

    listEmptyStateWrap: 'lcw-cargo-fee-list-tab__empty-state-wrap',
    listEmptyStatePaper: 'lcw-cargo-fee-list-tab__empty-state-paper',
    listFilterCompanyWrap: 'lcw-cargo-fee-list-tab__filter-company-field',
    inputSelectFilterCompany: 'lcw-cargo-fee-list-tab-input--select-filter-company',
    listFilterDateWrap: 'lcw-cargo-fee-list-tab__filter-date-range',
    inputButtonFilter: 'lcw-cargo-fee-list-tab-input--button-filter',

    listToolbarBackWrap: 'lcw-cargo-fee-list-tab__toolbar-back',
    inputButtonBack: 'lcw-cargo-fee-list-tab-input--button-back',
    listToolbarActionsWrap: 'lcw-cargo-fee-list-tab__toolbar-actions',
    inputButtonAddNew: 'lcw-cargo-fee-list-tab-input--button-add-new',
    inputButtonExportExcel: 'lcw-cargo-fee-list-tab-input--button-export-excel',
    listGridWrap: 'lcw-cargo-fee-list-tab__grid-wrap',

    costColumnHeader: 'lcw-cargo-fee-list-datagrid-header--cost',
    inputIconCostInfo: 'lcw-cargo-fee-list-datagrid-input--icon-cost-info',
    editCellWrap: 'lcw-cargo-fee-list-datagrid-actions-cell',
    inputButtonRowEdit: 'lcw-cargo-fee-list-tab-input--button-row-edit',

    drawerBody: 'lcw-cargo-fee-drawer__body',
    drawerFormFields: 'lcw-cargo-fee-drawer__form-fields',
    drawerCargoCompanyWrap: 'lcw-cargo-fee-drawer__cargo-company-field',
    inputSelectDrawerCargoCompany: 'lcw-cargo-fee-drawer-input--select-cargo-company',
    inputTextDrawerDesi: 'lcw-cargo-fee-drawer-input--text-desi',
    inputTextDrawerCost: 'lcw-cargo-fee-drawer-input--text-cost',
    drawerDateSection: 'lcw-cargo-fee-drawer__date-section',
    drawerDateSectionTitle: 'lcw-cargo-fee-drawer__date-section-title',
    drawerDateRangeWrap: 'lcw-cargo-fee-drawer__date-range',
    drawerFooter: 'lcw-cargo-fee-drawer__footer',
    inputButtonDrawerClear: 'lcw-cargo-fee-drawer-input--button-clear',
    inputButtonDrawerSave: 'lcw-cargo-fee-drawer-input--button-save',

    bulkRoot: 'lcw-cargo-fee-bulk-tab',
    bulkTitle: 'lcw-cargo-fee-bulk-tab__title',
    bulkSubtitle: 'lcw-cargo-fee-bulk-tab__subtitle',
    bulkCompanyWrap: 'lcw-cargo-fee-bulk-tab__company-field',
    inputSelectBulkCompany: 'lcw-cargo-fee-bulk-tab-input--select-company',
    bulkUploadSection: 'lcw-cargo-fee-bulk-tab__upload-section',
    bulkUploadExampleWrap: 'lcw-cargo-fee-bulk-tab__upload-example-wrap',
    bulkUploadDropzone: 'lcw-cargo-fee-bulk-tab__upload-dropzone',
    inputFileBulkExcel: 'lcw-cargo-fee-bulk-tab-input--file-excel',
    inputButtonSelectBulkExcel: 'lcw-cargo-fee-bulk-tab-input--button-select-excel',
    inputButtonUploadBulkExcel: 'lcw-cargo-fee-bulk-tab-input--button-upload-excel',
    bulkStatusChipsWrap: 'lcw-cargo-fee-bulk-tab__status-chips',
    chipBulkTotal: 'lcw-cargo-fee-bulk-tab__chip-total',
    chipBulkUpdated: 'lcw-cargo-fee-bulk-tab__chip-updated',
    chipBulkInserted: 'lcw-cargo-fee-bulk-tab__chip-inserted',
    chipBulkFailed: 'lcw-cargo-fee-bulk-tab__chip-failed',
    bulkFailedSection: 'lcw-cargo-fee-bulk-tab__failed-section',
    bulkFailedTitle: 'lcw-cargo-fee-bulk-tab__failed-title',
    bulkFailedTablePaper: 'lcw-cargo-fee-bulk-tab__failed-table-paper',
    bulkFailedTable: 'lcw-cargo-fee-bulk-tab__failed-table',
} as const;

export const lcwFeeCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
